// extracted by mini-css-extract-plugin
var _1 = "ra-art-bio-main";
var _2 = "ra-art-bio-text";
var _3 = "ra-art-bio-title-avatar";
var _4 = "ra-art-bio-title";
export { _1 as "artBioMainCls", _2 as "artBioTextCls", _3 as "artBioTitleAvatarCls", _4 as "artBioTitleCls" }
